<script setup>
import { computed, watch, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useWgptAccount } from 'dashboard/composables/wgpt/useAccount';

const store = useStore();
const router = useRouter();
const { isHubpostCarsAccount } = useWgptAccount();

const currentAccountId = useMapGetter('getCurrentAccountId');
const getAccount = useMapGetter('accounts/getAccount');

const isAccountLoaded = computed(
  () => !!getAccount.value(currentAccountId.value)?.id
);

const redirectUnlessHubpostCars = () => {
  if (isAccountLoaded.value && !isHubpostCarsAccount.value) {
    router.replace({ name: 'home' });
  }
};

watch(isAccountLoaded, redirectUnlessHubpostCars);

onMounted(() => {
  redirectUnlessHubpostCars();
  store.dispatch('wgptCarCatalog/get');
});
</script>

<template>
  <div
    class="flex flex-col justify-between flex-1 h-full m-0 overflow-auto bg-n-surface-1"
  >
    <router-view />
  </div>
</template>
